import { Fragment, ReactNode, useContext } from 'react';
import { HomeOutlined, RightOutlined } from '@ant-design/icons';
import { Link, useParams } from 'react-router-dom';
import { CompanyContext } from '../../../Contexts/CompanyContext';
import { Card, Button, Space } from 'antd';
import validator from 'validator';
import './styles.css';

interface IButtonCardProps {
    name: string,
    icon: ReactNode,
    action: () => void,
}

interface ICardHeaderProps {
    pageName: string,
    buttons?: IButtonCardProps[],
    linkPageBefore?: string,
    pageBeforeName?: string,
    hasPageBefore: boolean,
    isToHome?: boolean
}

const CardHeader = ({ pageName, buttons, hasPageBefore, linkPageBefore = "", pageBeforeName = "", isToHome = false }: ICardHeaderProps) => {
    const { id } = useParams();
    const { company } = useContext(CompanyContext);
    var isUUID = validator.isUUID(id ?? "");
    const url = (isUUID || isToHome) ? `/home/id=${company.id}` : "/managementMenu";
    const buttonAction = (action: any) => {
        action();
    }

    return (
        <Card
            style={{ borderRadius: '16px', marginBottom: '25px', border: '1px solid #e6e6e6' }}
            bodyStyle={{ padding: '16px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
        >
            <div className="header-content" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                <Link to={url} className="me-2" style={{ color: 'gray' }}>
                    <HomeOutlined /> <span>HomePage</span>
                </Link>
                {hasPageBefore ? (
                    <Fragment>
                        <RightOutlined style={{ color: 'gray', margin: '0 8px' }} />
                        {linkPageBefore && pageBeforeName && (
                            <Link to={linkPageBefore} className="me-2" style={{ color: 'gray', marginRight: '8px' }}>
                                {pageBeforeName}
                            </Link>
                        )}
                        <span style={{ color: 'gray' }}>
                            <RightOutlined /> {pageName}
                        </span>
                    </Fragment>
                ) : (
                    <span style={{ color: 'gray' }}>
                        <RightOutlined /> {pageName}
                    </span>
                )}
            </div>
            {buttons && (
                <Space>
                    {buttons.map((button, index) => (
                        <Button
                            key={index}
                            type="primary"
                            onClick={() => buttonAction(button.action)}
                            icon={button.icon}
                        >
                            {button.name}
                        </Button>
                    ))}
                </Space>
            )}
        </Card>
    );

}

export default CardHeader;